import React from "react";
import { Link } from "react-router-dom";
import { useNavContext } from "../context-api/nav-context";
import boilerExtra from "../Assets/Images/boilerPage/boilerextra.jpg";

const ContentRight = ({ data }) => {
  const { contRightTitle, contRightText, rightImgUrl } = data[3];
  const { closeNavbarMenu } = useNavContext();
  return (
    <section
      className="boiler-extras section-wrapper boiler-cover-margin"
      onMouseOver={closeNavbarMenu}
    >
      <div className="boilers-extras-img">
        <div className="img-container">
          <img src={rightImgUrl} alt="boiler extras" />
        </div>
      </div>
      <div className="boiler-extras-text">
        <h1 className="title">{contRightTitle}</h1>
        <p className="subtitle boiler-margin">{contRightText}</p>
        <Link to="/quotes" className="btn-hero btn-quote">
          Find A Boiler
        </Link>
      </div>
    </section>
  );
};

export default ContentRight;
